<template>
  <div class="bq-partner">
    <div class="bq-partner-title">
      <div
        v-for="(item, index) in partnerData"
        :key="item.id"
        class="bq-partner-item"
        :class="{ itemSelected: itemSelected == index }"
        @mouseover="chageItem(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="card-carousel-wrapper" :class="`carousel-${itemSelected}`">
      <span
        class="bq-partner-arrow left"
        @click="moveCarousel(-1)"
        :disabled="atHeadOfList"
      ></span>
      <div class="card-carousel">
        <div class="card-carousel--overflow-container">
          <div
            class="card-carousel-cards"
            ref="cardswrap"
            :style="{
              transform: 'translateX' + '(' + currentOffset + 'px' + ')',
            }"
          >
            <div
              class="card-carousel-card"
              v-for="item in imgsUrl"
              :key="item.id"
              ref="cards"
            >
              <img :src="item.icon" />
            </div>
          </div>
        </div>
      </div>
      <span
        class="bq-partner-arrow right"
        @click="moveCarousel(1)"
        ref="rarrow"
      ></span>
    </div>
  </div>
</template>

<script>
import { partnerData } from './partner';

export default {
  name: 'Partner',

  data() {
    return {
      partnerData,
      itemSelected: 0,
      imgsUrl: partnerData[0].patter,
      currentOffset: 0,
      windowSize: 7,
      paginationFactor: 320,
    };
  },

  methods: {
    moveCarousel(direction) {
      const last = this.$refs['cards'].length - 1;
      const arrowDom = this.$refs['rarrow'].getBoundingClientRect();
      const lastDom = this.$refs['cards'][last].getBoundingClientRect();

      if (direction === 1 && !(lastDom.width + lastDom.left <= arrowDom.left)) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },

    chageItem(index) {
      this.itemSelected = index;
      this.imgsUrl = partnerData[index].patter;
      this.currentOffset = 0;
    },
  },
  computed: {
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
